import React, { useCallback } from 'react';
import { BiDataHook, BiEventType } from '@wix/da-bi/pkg/constants';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import FavStarFillIcon from '../../Icons/24x24/FavStarFill';
import useDeviationStats from '../useDeviationStats';
import Stat from '../Stat';
var FaveStat = function (_a) {
    var deviation = _a.deviation, onlyNumbers = _a.onlyNumbers, className = _a.className, showFavouritedByModal = _a.showFavouritedByModal;
    var _b = useDeviationStats(deviation), faves = _b.faves, isFavouritable = _b.isFavouritable;
    var statsPopup = useFlag('stats_popup');
    var openFavouritedModal = useCallback(function () {
        statsPopup && faves > 0 && showFavouritedByModal(deviation);
    }, [statsPopup, faves, deviation]);
    return !isFavouritable ? null : (React.createElement(Stat, { className: className, deviation: deviation, icon: FavStarFillIcon, statNameLocaleKey: "deviation.stats.faves", statCount: faves, onlyNumbers: onlyNumbers, userListType: "favourite", dataHook: BiDataHook.DEVIATION_FAVES_COUNTER, tooltipDataHook: BiDataHook.DEVIATION_FAVERS_LIST, onClick: openFavouritedModal, biData: {
            evid: BiEventType.DEFAULT,
            click_info: 'favourites',
        } }));
};
FaveStat.displayName = 'FaveStat';
export default FaveStat;
//# sourceMappingURL=FaveStat.js.map